import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
import { DepartmentService } from './department.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  selectedService;
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;

  constructor(
    private http: HttpClient
  ) { }


  async getServices(department) {
    return await department.$getServices();
  }

  async set(service) {
    this.selectedService = service;
  }

  async get() {
    return this.selectedService;
  }
}
